module.exports = __webpack_public_path__ + "static/media/lang-enus.4a52512e.svg";